/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-globals */
// eslint-disable import/no-named-as-default-member
import * as featureCodes from './FeatureCodeConstants';

const FeatureManager = Backbone.View.extend({
  codes: featureCodes,
  pendoGuideLookup: featureCodes.pendoGuideLookup,

  status: featureCodes.status,

  initialize() {
    this.listenTo(Backbone, 'dom-update', this.handleDomUpdate);

    this.currentUser = loginContext.getDefaultLoginDetails();
    this.currentUserProfile = this.currentUser.profile;

    this.restrictedFeatures = {};

    this.timeoutID = null;

    this.listenToOnce(Backbone, 'userstats-populated', this.handleDomUpdate);
  },

  // this will trigger a user stats update to fetch the current status of the
  // plans
  refreshFeaturePlansStatus(callback) {
    Backbone.trigger('reset:polling');
    this.listenToOnce(Backbone, 'userstats-populated', () => {
      this.handleDomUpdate();
      if (callback) {
        callback();
      }
    });
  },

  isFeatureRestricted(featureCode, currentQuantity) {
    const feature = this.restrictedFeatures[featureCode];
    if (!feature) {
      return false;
    }
    const { status, quantity } = feature;

    return (quantity && currentQuantity >= quantity) || status === this.status.RESTRICTED;
  },

  createRestrictedItem(feature) {
    let restrictedItem = {
      code: feature.code,
      status: this.currentUserProfile === 'Administrator' || this.currentUserProfile === 'Team Member' ? this.status.RESTRICTED : this.status.HIDDEN,
      pendoGuideId: this.getPendoGuideId(feature.code),
    };

    if (feature.quantity) {
      restrictedItem = {
        ...restrictedItem,
        status: feature.has_reached_limit ? this.status.LIMITED : this.status.AVAILABLE,
        quantity: feature.quantity,
      };
    }

    return restrictedItem;
  },

  setPlanFeaturesInfo(featureRestrictionsData) {
    this.restrictedFeatures = featureRestrictionsData.reduce((restrictedFeatures, feature) => {
      restrictedFeatures[feature.code] = this.createRestrictedItem(feature);
      return restrictedFeatures;
    }, {});
  },

  isFeatureTriggerVisible(featureCode) {
    // in any case if the feature name is not in the pendoguide lookup list always return available
    const feature = this.restrictedFeatures[featureCode];

    if (typeof this.pendoGuideLookup.admin[featureCode] === 'undefined' || !feature) {
      return true;
    }

    return feature.status !== this.status.HIDDEN;
  },

  getFeatureStatus(featureCode) {
    const feature = this.restrictedFeatures[featureCode];

    if (feature) {
      return feature.status;
    }

    return this.status.AVAILABLE;
  },

  handleDomUpdate(e, forceRun) {
    $('.popover').hide();

    if (this.timeoutID) {
      // already triggered
      return;
    }

    if (!forceRun) {
      // wait 100 ms before triggering
      this.timeoutID = setTimeout(() => {
        this.timeoutID = null;
        this.handleDomUpdate(null, true);
      }, 400);

      return;
    }

    // check element with feature-check class name and add click event if restricted
    $('.feature-check').each((index, event) => {
      const $trigger = $(event);
      const featureCode = $trigger.attr('data-feature-code');

      // if it can be limited then get the current quantity added
      Backbone.trigger(`quantity-request:${featureCode}`, $trigger);

      if (featureCode) {
        this.setupFeatureGatingTrigger($trigger, featureCode);
      }
    });
  },

  setupFeatureGatingTrigger($trigger, featureCode) {
    const status = this.getFeatureStatus(featureCode);
    if (!featureCode || !this.restrictedFeatures[featureCode] || status === this.status.AVAILABLE) {
      return;
    }

    if (status === this.status.HIDDEN && $trigger?.length && !this.isFeatureTriggerVisible(featureCode)) {
      // Should already be hidden in template
      // hide anyway
      $trigger.hide();
    } else if (status === this.status.RESTRICTED || status === this.status.LIMITED) {
      // if restricted then overide click event
      if ($trigger?.length) {
        $trigger.off('click');
        $trigger.off('mousedown');
        $trigger.popover('destroy');
        $trigger.tooltip('destroy');
        $trigger.removeAttr('title');
        $trigger.removeAttr('data-original-title');
        $trigger.on('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.openFeatureGatingPopup(featureCode);
        });
      }
    }
  },

  openFeatureGatingPopup(featureCode) {
    let pendoIsWorking = false;

    const feature = this.restrictedFeatures[featureCode];

    if (feature?.pendoGuideId && window?.pendo?.showGuideById) {
      pendoIsWorking = window.pendo.showGuideById(feature?.pendoGuideId);
    }

    if (!pendoIsWorking) {
      Utils.notify(window.lookup('The current plan you\'re using does not grant access to this feature.'), 'alert', null, true);
    }
  },

  getPendoGuideId(featureCode) {
    let userRole = 'team_member';
    let pendoGuideId = '';

    if (this.currentUserProfile == 'Administrator') {
      userRole = 'admin';
    }

    if (this.pendoGuideLookup[userRole][featureCode]) {
      pendoGuideId = this.pendoGuideLookup[userRole][featureCode];
    }

    return pendoGuideId;
  },

  removeTabFeaturesIfHidden(tabs) {
    _.each(tabs, (tab) => {
      if (tab.dataFeatureCode && !js_featurMngr.isFeatureTriggerVisible(tab.dataFeatureCode)) {
        tabs = _.reject(tabs, (tabObj) => tabObj.id == tab.id);
      }
    });

    return tabs;
  },

});

export default FeatureManager;
